import moment from 'moment';
import { randomString as _randomString } from './randomString';
import { getIn18Text } from 'api';
export const randomString = _randomString;
export const getDurationText = (startDate, endDate, allDay, weekDaySuffix = true, weekDayFloat = false, totalSeconds = 0) => {
    let startStr = '';
    let endStr = '';
    let affixStr = '';
    let startDateFormatStr = getIn18Text('MMYUEDD');
    let endDateFormatStr = getIn18Text('MMYUEDD');
    const timeDiff = totalSeconds ? totalSeconds / 60 / 60 + new Date().getTimezoneOffset() / 60 || 0 : 0;
    const tzStartDate = moment(startDate).add(timeDiff, 'hour');
    const tzEndDate = moment(endDate).add(timeDiff, 'hour');
    const tzNow = moment(endDate).add(timeDiff, 'hour');
    let affixStartStr = '';
    let affixEndStr = '';
    if (weekDaySuffix) {
        if (!weekDayFloat) {
            startDateFormatStr += '(ddd)';
            endDateFormatStr += '(ddd)';
        }
        else {
            const start = moment(tzStartDate).startOf('day');
            const end = moment(tzEndDate).startOf('day');
            const today = moment(tzNow).startOf('day');
            const tomorrow = today.clone().add(1, 'day');
            const dayAfterTomorrow = tomorrow.clone().add(1, 'day');
            if (start.isSame(today)) {
                affixStartStr = getIn18Text('(JINTIAN)');
            }
            else if (start.isSame(tomorrow)) {
                affixStartStr = getIn18Text('(MINGTIAN)');
            }
            else if (start.isSame(dayAfterTomorrow)) {
                affixStartStr = getIn18Text('(HOUTIAN)');
            }
            else {
                startDateFormatStr += '(ddd)';
            }
            if (end.isSame(today)) {
                affixEndStr += getIn18Text('(JINTIAN)');
            }
            else if (end.isSame(tomorrow)) {
                affixEndStr += getIn18Text('(MINGTIAN)');
            }
            else if (end.isSame(dayAfterTomorrow)) {
                affixEndStr += getIn18Text('(HOUTIAN)');
            }
            else {
                endDateFormatStr += '(ddd)';
            }
        }
    }
    const startMoment = moment(tzStartDate);
    const endMoment = moment(tzEndDate);
    if (allDay && endMoment.diff(startMoment, 'days') > 0) {
        endMoment.add(-1, 'days');
    }
    const crossDay = !endMoment.isSame(startMoment, 'day');
    const crossYear = startMoment.year() !== moment(tzNow).year() || endMoment.year() !== moment(tzNow).year();
    startStr = crossYear ? `${startMoment.year()}年` : '';
    endStr = crossYear && crossDay ? `${endMoment.year()}年` : '';
    startStr += startMoment.format(startDateFormatStr + ' ') + affixStartStr;
    endStr += crossDay ? endMoment.format(endDateFormatStr + ' ') + affixEndStr : '';
    affixStr = getDurationTag(startMoment, endMoment, allDay);
    if (!allDay) {
        startStr += startMoment.format('HH:mm');
        endStr += endMoment.format('HH:mm');
    }
    startStr = endStr ? `${startStr} ~ ` : startStr;
    return {
        startStr,
        endStr,
        affixStr,
        crossDay,
        crossYear,
    };
};
export const getDurationTag = (startMoment, _endMoment, allDay = false) => {
    const endMoment = _endMoment.clone().add(allDay ? 1 : 0, 'days');
    let diffDays = endMoment.diff(startMoment, 'days');
    const diffHours = endMoment.diff(startMoment, 'hours') - diffDays * 24;
    const diffMinutes = endMoment.diff(startMoment, 'minutes') - (diffDays * 24 + diffHours) * 60;
    if (diffDays > 999) {
        return getIn18Text('999+TIAN');
    }
    if (diffDays === 0 && allDay) {
        diffDays = 1;
    }
    return `${diffDays ? `${diffDays}天` : ''}${diffHours ? `${diffHours}小时` : ''}${diffMinutes ? `${diffMinutes}分钟` : ''}`;
};
const rrule = (val, start) => {
    const wk = ['SU', 'MO', 'TU', 'WE', 'TH', 'FR', 'SA'];
    const dd = moment(start).format('d');
    const d = moment(start).format('D');
    let monthly = d;
    if (+d > 20) {
        monthly = d + ',-1;BYSETPOS=1';
    }
    const map = [
        '',
        'FREQ=DAILY;WKST=MO',
        'FREQ=WEEKLY;WKST=MO;BYDAY=MO,TU,WE,TH,FR',
        'FREQ=WEEKLY;WKST=MO;BYDAY=' + wk[dd],
        'FREQ=MONTHLY;WKST=MO;BYMONTHDAY=' + monthly,
        'FREQ=YEARLY;WKST=MO',
    ];
    return map[val];
};
const attendee = receiver => {
    if (!Array.isArray(receiver))
        return '';
    const reveiverMap = receiver.map(i => {
        const role = i.mailMemberType === 'cc' ? 'OPT-PARTICIPANT' : 'REQ-PARTICIPANT';
        return `ATTENDEE;CN="${i.contact.contact.contactName}";CUTYPE=INDIVIDUAL;ROLE=${role};PARTSTAT=NEEDS-ACTION:mailto:${i.contact.contact.accountName}`;
    });
    const r = navigator.appVersion.indexOf('Win') !== -1 ? '\r\n' : '\n';
    return reveiverMap.join(r);
};
const ics = ({ start, end, name = 'calendar', suffix = '.ics', uid, rruleVal, organizer, receiver, desc = '', location, summary = '' }) => {
    const { timeZone } = Intl.DateTimeFormat().resolvedOptions();
    const DTSTART = `TZID=${timeZone}:${moment(start).format('YYYYMMDDTHHmmss')}`;
    const DTEND = `TZID=${timeZone}:${moment(end).format('YYYYMMDDTHHmmss')}`;
    const CREATED = moment(new Date()).format('YYYYMMDDTHHmmss') + 'Z';
    let RRULE = [];
    const rCal = rrule(rruleVal, start);
    if (rCal) {
        RRULE = ['RRULE:' + rCal];
    }
    const ORGANIZER = `CN="${organizer.contactName}":mailto:${organizer.accountName}`;
    const ATTENDEE = attendee(receiver);
    const DTSTAMP = CREATED;
    const data = [
        'BEGIN:VCALENDAR',
        'PRODID:-//Netease Corporation//Netease QiyeMail 2.0//EN',
        'VERSION:2.0',
        'CALSCALE:GREGORIAN',
        'METHOD:REQUEST',
        'BEGIN:VEVENT',
        'DTSTART;' + DTSTART,
        'DTEND;' + DTEND,
        'DTSTAMP:' + DTSTAMP,
        ...RRULE,
        'ORGANIZER;' + ORGANIZER,
        ATTENDEE,
        'UID:' + uid,
        'CREATED:' + CREATED,
        'DESCRIPTION:' + desc,
        'LAST-MODIFIED:' + CREATED,
        'LOCATION:' + location,
        'SEQUENCE:0',
        'STATUS:CONFIRMED',
        'SUMMARY:' + summary,
        'TRANSP:OPAQUE',
        'END:VEVENT',
        'END:VCALENDAR',
    ];
    const r = navigator.appVersion.indexOf('Win') !== -1 ? '\r\n' : '\n';
    const dataString = data.join(r);
    const daraBlob = new Blob([dataString]);
    return new File([daraBlob], name + suffix);
};
export default ics;
